import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ingredients-container" }
const _hoisted_2 = { class: "ingredients-list" }
const _hoisted_3 = { class: "icon-container" }
const _hoisted_4 = {
  key: 0,
  class: "ingredient-display"
}
const _hoisted_5 = {
  key: 1,
  class: "ingredient-display"
}
const _hoisted_6 = {
  key: 0,
  class: "no-ingredients"
}
const _hoisted_7 = { class: "icon-container" }

import { Plus, Delete } from '@element-plus/icons-vue';
import type { Ingredient } from '@/types/recipe';


export default /*@__PURE__*/_defineComponent({
  __name: 'IngredientsList',
  props: {
    ingredients: {},
    editable: { type: Boolean }
  },
  emits: ["updateIngredient", "addIngredient", "removeIngredient"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updateIngredient = (
  index: number,
  field: 'name' | 'amount',
  value: string
) => {
  // Map 'name' to 'ingredientName' for the API
  const apiField = field === 'name' ? 'ingredientName' : field;
  emit('updateIngredient', index, apiField, value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ingredients, (ingredient, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "ingredient-item"
        }, [
          (_ctx.editable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_input, {
                  "model-value": 
              typeof ingredient === 'object'
                ? ingredient.ingredientName
                : ingredient
            ,
                  placeholder: "Ingredient name",
                  style: {"flex":"2"},
                  "onUpdate:modelValue": ($event: any) => (updateIngredient(index, 'name', $event))
                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                _createVNode(_component_el_input, {
                  "model-value": 
              typeof ingredient === 'object' ? ingredient.amount : ''
            ,
                  placeholder: "Amount",
                  style: {"flex":"1"},
                  "onUpdate:modelValue": ($event: any) => (updateIngredient(index, 'amount', $event))
                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  circle: "",
                  disabled: _ctx.ingredients.length <= 1,
                  onClick: ($event: any) => (_ctx.$emit('removeIngredient', index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, [
                      _createVNode(_unref(Delete), { class: "button-icon" })
                    ])
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (typeof ingredient === 'object')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("strong", null, _toDisplayString(ingredient.amount), 1),
                      _createTextVNode(" " + _toDisplayString(ingredient.ingredientName), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(ingredient), 1))
              ], 64))
        ]))
      }), 128)),
      (!_ctx.ingredients.length && !_ctx.editable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No ingredients listed "))
        : _createCommentVNode("", true),
      (_ctx.editable)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            class: "custom-button",
            style: {"margin-top":"1rem","width":"100%"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addIngredient')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_unref(Plus), { class: "plus-button-icon" })
              ]),
              _cache[1] || (_cache[1] = _createTextVNode(" Add Ingredient "))
            ]),
            _: 1,
            __: [1]
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})